import { render, staticRenderFns } from "./index.vue?vue&type=template&id=247b6a8c&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=247b6a8c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "247b6a8c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/daniel/work/jiangxi/fed-sd-visual-web-static/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('247b6a8c')) {
      api.createRecord('247b6a8c', component.options)
    } else {
      api.reload('247b6a8c', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=247b6a8c&scoped=true&", function () {
      api.rerender('247b6a8c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/bussiness/south-mec/home/index.vue"
export default component.exports